import combineReducers from 'redux/lib/combineReducers';

import payroll from './payroll';
import setting from './setting';

export default combineReducers({
  payroll,
  setting,
});
